import { resource } from '@util/resource';
import { Observable } from 'rxjs';
import { Injectable} from '@angular/core';
import { NotificationDWS } from '@interfaces/dws/notification-dws';
import { AdminNotificationDetail, AdminNotificationPage, AdminNotificationStats } from '@interfaces/dws/admin-notification';
import { AdminLoginAsWineryService } from './admin-login-as-winery.service';


@Injectable({
  providedIn: 'root'
})
export class NotificationsAdminService {
  constructor(private adminLoginAsWineryService: AdminLoginAsWineryService) {}

  /** Prefer stored admin JWT (survives login-as-winery); else interceptor via x-admin-authorization. */
  private adminRequest(path: string) {
    const adminToken = this.adminLoginAsWineryService.getOriginalAdminToken();
    if (adminToken) {
      return resource(path).bearer(adminToken.replace('Bearer ', ''));
    }
    return resource(path).headers({ 'x-admin-authorization': '1' });
  }

  pushNotification(notification: NotificationDWS): Observable<unknown> {
    return this.adminRequest('crm://admin/notifications/push').post(notification);
  }

  listNotifications(page: number = 0, count: number = 50, search?: string): Observable<AdminNotificationPage> {
    return this.adminRequest('crm://admin/notifications')
      .params({ page, count, search })
      .get<AdminNotificationPage>();
  }

  getNotification(campaignId: string): Observable<AdminNotificationDetail> {
    return this.adminRequest('crm://admin/notifications/campaignId')
      .params({ campaignId })
      .get<AdminNotificationDetail>();
  }

  updateNotification(campaignId: string, notification: NotificationDWS): Observable<unknown> {
    return this.adminRequest('crm://admin/notifications/campaignId')
        .params({ campaignId })
        .put(notification);
  }

  setPublicationPaused(campaignId: string, paused: boolean): Observable<unknown> {
    return this.adminRequest('crm://admin/notifications/campaignId/publication-paused')
        .params({ campaignId })
        .put({ paused });
  }

  deleteNotification(campaignId: string): Observable<void> {
    return this.adminRequest('crm://admin/notifications/campaignId')
      .params({ campaignId })
      .delete();
  }

  getNotificationStats(campaignId: string): Observable<AdminNotificationStats> {
    return this.adminRequest('crm://admin/notifications/campaignId/stats')
      .params({ campaignId })
      .get<AdminNotificationStats>();
  }
}
